import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { useTheme } from "@mui/material";
import { Item } from "../../../../layouts/Theme";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import advancedFormatPlugin from 'dayjs/plugin/advancedFormat';
import weekOfYearPlugin from 'dayjs/plugin/weekOfYear';
import isSameOrAfterPlugin from 'dayjs/plugin/isSameOrAfter';
import useWidgetStore from '../../store/useWidgetStore';
const ANIMATION_SPEED = 400;
export default function WeekPicker(props) {
    const theme = useTheme();
    const { language, setSelectedDate, selectedDate } = useWidgetStore();
    const containerRef = useRef(null);
    const [disabled1, setDisabled1] = useState(true);
    const [disabled2, setDisabled2] = useState(false);
    const [currentDate, setCurrentDate] = useState();
    const [weeknumber, setWeeknumber] = useState();
    const goBack = () => {
        var _a;
        (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('slideLeft');
        setDisabled1(true);
        setTimeout(() => {
            var _a;
            if (weeknumber && currentDate) {
                let newDate = dayjs(currentDate).subtract(1, 'week');
                setCurrentDate(newDate.toDate());
                (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('slideLeft');
                setDisabled2(false);
                let d = dayjs(new Date()), monday = d.subtract(d.day() - 1, 'day');
                dayjs.extend(isSameOrAfterPlugin);
                newDate = dayjs(newDate).subtract(1, 'week');
                if (newDate.isSameOrAfter(monday)) {
                    setDisabled1(false);
                }
            }
        }, ANIMATION_SPEED);
    };
    const goNext = () => {
        var _a;
        (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('slideRight');
        setDisabled2(true);
        setTimeout(() => {
            var _a;
            if (weeknumber && currentDate) {
                let newDate = dayjs(currentDate).add(1, 'week');
                setCurrentDate(newDate.toDate());
                (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('slideRight');
                setDisabled1(false);
                setDisabled2(false);
            }
        }, ANIMATION_SPEED);
    };
    useEffect(() => {
        if (!currentDate) {
            setCurrentDate(new Date());
        }
    }, []);
    useEffect(() => {
        if (currentDate) {
            dayjs.extend(advancedFormatPlugin);
            dayjs.extend(weekOfYearPlugin);
            let d = dayjs(currentDate).locale(language);
            setWeeknumber(parseInt(d.format('w')));
        }
    }, [currentDate]);
    const days = useMemo(() => {
        if (currentDate) {
            let d = dayjs(currentDate);
            let monday = d.subtract(d.day() - 1, 'day'), start = monday.subtract(1, 'week');
            const days = [];
            for (let i = 0; i < 21; i++) {
                days.push(start.format('YYYY-MM-DD'));
                start = start.add(1, 'day');
            }
            return days;
        }
    }, [weeknumber]);
    const onClick = (event) => {
        setSelectedDate(event.target.closest('button').getAttribute('rel'));
    };
    return (_jsx(_Fragment, { children: days && (_jsxs(Stack, { direction: "row", spacing: 0, className: `weekpicker-${weeknumber}`, children: [_jsx(Item, { sx: {
                        textAlign: "center",
                        lineHeight: "64px",
                        width: '16px'
                    }, children: _jsx(IconButton, { onClick: goBack, disabled: disabled1, sx: {
                            padding: 0,
                            width: '24px',
                            "& svg": {
                                marginLeft: '8px'
                            }
                        }, children: _jsx(ArrowBackIosIcon, {}) }) }), _jsx(Box, { sx: {
                        // background: '#c00',
                        overflow: 'hidden',
                        width: '434px',
                        "& .slideLeft": {
                            transform: "translate(0, 0) scale(1)",
                            transition: `all ${ANIMATION_SPEED}ms`
                        },
                        "& .slideRight": {
                            transform: "translate(-868px, 0) scale(1)",
                            transition: `all ${ANIMATION_SPEED}ms`
                        }
                    }, children: _jsx(Stack, { direction: "row", spacing: 0, sx: {
                            transform: "translate(-434px, 0) scale(1)",
                        }, ref: containerRef, children: days.map((day, index) => {
                            let d = dayjs(day).locale(language), selected = selectedDate ? selectedDate[0] : new Date(), t = dayjs(selected).format('YYYY-MM-DD');
                            return (_jsxs(Button, { rel: day, onClick: onClick, sx: Object.assign({ textAlign: "center", background: '#fff', border: "#eee 1px solid", width: "62px", minWidth: "62px", height: '80px', display: 'inline-block', lineHeight: 1, padding: 0, fontSize: '1rem', borderRadius: 0 }, (day === t && {
                                    backgroundColor: theme.palette.primary.main,
                                    color: '#fff',
                                    "& .MuiTypography-root": {
                                        color: '#fff'
                                    },
                                    "&:hover": {
                                        backgroundColor: theme.palette.primary.main,
                                    }
                                })), children: [d.format('dd'), _jsx(Typography, { variant: "h6", sx: {
                                            my: 0,
                                            fontWeight: 700,
                                            lineHeight: 1.4
                                        }, children: d.format('D') }), d.format('MMM')] }, index));
                        }) }) }), _jsx(Item, { sx: {
                        textAlign: "center",
                        lineHeight: "64px",
                        width: '16px'
                    }, children: _jsx(IconButton, { onClick: goNext, disabled: disabled2, sx: {
                            padding: 0,
                            width: '24px'
                        }, children: _jsx(ArrowForwardIosIcon, {}) }) })] })) }));
}
